// extracted by mini-css-extract-plugin
module.exports = {"root":"SockyCanvas_root__3pKGt","canvas":"SockyCanvas_canvas__lkw2J"};